import arrayEquals from "./array-equals"

export default function(array1, array2) {
  try {
    return (
      array1.length === array2.length &&
      array1.every(
        (item, idx) => JSON.stringify(array2[idx]) === JSON.stringify(item)
      )
    )
  } catch (e) {
    return arrayEquals(array1, array2)
  }
}
